
import DocumentDownload from "../../../assets/outline/DocumentDownload.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DocumentDownloadIcon({ className, dataTestid = "DocumentDownloadIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DocumentDownload data-testid={dataTestid} className={classes} {...rest} />
  );
}
